export const QA_NAME_VIEWING_FORM_NO_APPLICANTS_ACTION =
  'viewingFormNoApplicantsAction'

export const QA_NAME_VIEWING_FORM_NO_SLOTS_ACTION = 'viewingFormNoSlotsAction'

export const QA_NAME_VIEWING_FORM_MODAL = 'viewingFormModal'

export const QA_NAME_VIEWING_FORM_DURATION = 'viewingFormDuration'

export const QA_NAME_VIEWING_FORM_APPLICANT = 'viewingFormApplicant'

export const QA_NAME_VIEWING_FORM_ERROR = 'viewingFormError'

export const QA_NAME_VIEWING_FORM_LISTING = 'viewingFormListing'

export const QA_NAME_VIEWING_FORM_REPEAT = 'viewingFormRepeat'

export const QA_NAME_VIEWING_FORM_SERIES_WARNING = 'viewingFormSeriesWarning'

export const QA_NAME_VIEWING_FORM_SLOT = 'viewingFormSlot'

export const QA_NAME_VIEWING_FORM_MODE = 'viewingFormMode'

export const QA_NAME_VIEWING_FORM_START = 'viewingFormStart'

export const QA_NAME_VIEWING_FORM_SUBMIT = 'viewingFormSubmit'

export const VIEWING_FORM_FIELD_NAME = {
  applicant: 'applicant_id',
  duration: 'duration_min',
  listing: 'listing_id',
  mode: 'mode',
  repeatUntil: 'repeat_until',
  slot: 'slot_id',
  start: 'start',
  timeSource: 'time_source',
  withRepeat: 'with_repeat',
}

export const VIEWING_FORM_TIME_SOURCE = {
  adHoc: 'ad-hoc',
  slot: 'slot',
}

export const VIEWING_FORM_TIME_SOURCE_LABEL_KEY = {
  [VIEWING_FORM_TIME_SOURCE.adHoc]: 'RentalPortal.ViewingFormTimeAdHocKey',
  [VIEWING_FORM_TIME_SOURCE.slot]: 'RentalPortal.ViewingFormTimeSlotKey',
}

export const VIEWING_FORM_MODE = {
  addSlot: 'addSlot',
  book: 'book',
}

export const VIEWING_FORM_MODE_LABEL_KEY = {
  [VIEWING_FORM_MODE.addSlot]: 'RentalPortal.ViewingFormModeAddSlotKey',
  [VIEWING_FORM_MODE.book]: 'RentalPortal.ViewingFormModeBookKey',
}

export const VIEWING_FORM_DURATION_DEFAULT = 30

export const VIEWING_FORM_DURATION_OPTIONS = [15, 30, 45, 60, 90]

export const VIEWING_FORM_SERIES_WARNING_LIMIT = 50
